// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--o28y_","error":"error--vSHla"};